import { FileSignature, SendHorizontal } from "lucide-react";

export default function StepEmailSign({
  customerEmail,
  onSendMail,
}) {
  const hasEmail = !!customerEmail?.trim();
  return (
    <div className="mx-auto max-w-md space-y-6 font-sans">
      {/* ===== SUBMIT FOR SIGNATURE CARD ===== */}
      <div
        className="relative w-full rounded-3xl border
          bg-white p-6 shadow-lg transition-all duration-300
          hover:-translate-y-0.5 hover:shadow-xl"
      >
        <div className="flex items-center gap-4 mb-5">
          <div
            className="flex h-12 w-12 items-center justify-center rounded-2xl
              bg-gradient-to-br from-sky-500 to-cyan-500
              text-white shadow-md"
          >
            <FileSignature size={22} />
          </div>

          <div>
            <h3 className="text-lg font-extrabold text-slate-900">
              Submit for Signature
            </h3>
            <p className="text-xs font-medium text-slate-400">
              Saves the document. The customer will receive a link by email,
              and they can also sign it from the Document Search page using
              their reference number.
            </p>
          </div>
        </div>

        <div className="mb-4 rounded-2xl bg-slate-50 px-4 py-3 ring-1 ring-slate-200">
          <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">
            Sending to
          </p>
          <p
            className="truncate text-sm font-semibold text-slate-900"
            title={customerEmail}
          >
            {customerEmail || "No email provided in the form"}
          </p>
        </div>

        <button
          disabled={!hasEmail}
          onClick={onSendMail}
          className={`group flex w-full items-center justify-center gap-2
            rounded-2xl py-4 text-sm font-extrabold tracking-wide
            transition-all duration-300 active:scale-[0.97]
            ${
              hasEmail
                ? " bg-gradient-to-br from-sky-500 to-cyan-500 text-white shadow-lg hover:brightness-110"
                : "bg-slate-100 text-slate-400 cursor-not-allowed"
            }`}
        >
          <span>Submit for Signature</span>
          <SendHorizontal
            size={16}
            className={`transition-transform duration-300 ${
              hasEmail
                ? "group-hover:translate-x-1 group-hover:-translate-y-0.5"
                : ""
            }`}
          />
        </button>
      </div>
    </div>
  );
}
